import React, { useState, useEffect } from "react";
import color1 from "../../assets/images/dummy/color1.png";
import { Link, useNavigate } from "react-router-dom";
import Constants from "../Variables/Constants";
import axios from "axios";
import { toast } from "react-toastify";
import { Stage, Layer, Image as KonvaImage } from "react-konva";
import { useDispatch, useSelector } from "react-redux";
import { setCartItems } from "../../redux/cartSlice"; // Import the action
import Loader from "../../components/Loader";
import NoData from "../../components/NoData";
import Navigation from "../../components/Navigation";
import "./Carts.css";
const Carts = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [cartData, setCartData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [flag, setFlag] = useState(false);
  const token = localStorage.getItem("token");
  const dispatch = useDispatch(); // Initialize dispatch
  console.log("cartData", cartData);

  const hasCustomization = (item) =>
    item?.custom_product === "yes" && item?.customized_image_id;

  const getCartItemPrice = (item) =>
    hasCustomization(item)
      ? Number(item?.customized_image_id?.price || 0)
      : Number(item?.price || 0);

  useEffect(() => {
    if (cartData) {
      if (Array.isArray(cartData)) {
        let sum = 0;
        cartData.map((item) => {
          sum = sum + getCartItemPrice(item) * Number(item?.quantity || 0);
        });
        setTotalAmount(sum);
      }
    }
  }, [cartData]);

  const fetchMultipleProducts = async () => {
    try {
      setLoading(true);
      const localCart = localStorage.getItem("cart");
      if (localCart) {
        const productIds = JSON.parse(localCart);

        const resp = await axios.post(Constants.postUrls.getMultipleProduct, {
          product_ids: productIds.map((io) => io._id),
        });
        if (resp.data.status === "success") {
          const cartData = resp.data.data;
          if (cartData && Array.isArray(cartData)) {
            cartData.map((cart) => {
              productIds.map((io) => {
                if (io._id === cart._id) {
                  cart.quantity = io.quantity;
                }
              }); 
            });
            localStorage.setItem("cart", JSON.stringify(cartData));
            dispatch(setCartItems(cartData));
            setLoading(false);
            setCartData(JSON.parse(JSON.stringify(cartData)));
          } else {
            setLoading(false);
            setCartData([]);
            dispatch(setCartItems([]));
            localStorage.removeItem("cart");
          }
        } else {
          setLoading(false);
          setCartData([]);
          dispatch(setCartItems([]));
          localStorage.removeItem("cart");
        }
      } else {
        setLoading(false);
        setCartData([]);
        dispatch(setCartItems([]));
        localStorage.removeItem("cart");
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error("No items in the cart.");
      }
    } catch (err) {
      console.error(err);
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Failed to fetch product details.");
      setLoading(false);
    }
  };

  const fetchCart = async () => {
    setLoading(true);
    try {
      const res = await axios.get(Constants.getUrls.getCart, {
        headers: { Authorization: token },
      });
      if (res.data.status === "success") {
        const data = res.data.data.docs;
        const arr = [];
        if (data && Array.isArray(data) && data.length > 0) {
          data.map((item) => {
            arr.push({
              ...item,
              product_data: {
                ...item.product_id,
              },
              product_id: item.product_id._id,
              images: item.product_id.images,
              name: item.product_id.name,
              price: item.product_id.price,
              category_id: item.product_id.category,
              collection_id: item.product_id.sub_category,
            });
          });
          localStorage.removeItem("cart");
          setCartData(arr);
          dispatch(setCartItems(arr));
          setLoading(false);
        } else {
          setLoading(false);
          setCartData([]);
          dispatch(setCartItems([]));
          localStorage.removeItem("cart");
        }
      } else {
        setLoading(false);
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error("Failed to fetch cart items.");
        setCartData([]);
        dispatch(setCartItems([]));
        localStorage.removeItem("cart");
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Failed to fetch cart items.");
    }
  };

  useEffect(() => {
    if (token) {
      fetchCart();
    } else {
      fetchMultipleProducts();
    }
  }, [token, flag]);

  const updateQuantity = async ({ cartId, quantity }) => {
    if (quantity > 0) {
      try {
        const resp = await axios.put(
          `${Constants.postUrls.updateQuantity}${cartId}`,
          { quantity: quantity },
          { headers: { Authorization: token } }
        );
        if (resp.data.status === "success") {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.success("Item quantity updated in cart!", {
            style: { backgroundColor: "green", color: "white" },
          });
          setFlag(!flag);
        }
      } catch (err) {
        console.error(err);
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error("Failed to update item quantity.");
      }
    } else {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Quantity must be greater than 0.");
    }
  };

  if (loading) {
    return (
      <>
        <center>
          <Loader />
        </center>
      </>
    );
  }

  if (cartData.length === 0) {
    return (
      <div className="Carts px-5">
        <Navigation />

        <NoData text={"Your cart is empty."} image={"/NoCart.png"} />
      </div>
    );
  }

  const handleRemoveFromCart = async (ids) => {
    try {
      const resp = await axios.delete(
        `${Constants.deleteUrls.removeCartItem}`,
        {
          headers: { Authorization: token },
          data: { ids },
        }
      );
      if (resp.data.status === "success") {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.success("Item removed from cart!", {
          style: { backgroundColor: "green", color: "white" },
        });
        fetchCart();
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error("Failed to remove item from cart.");
      }
    } catch (err) {
      console.error(err);
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Failed to remove item from cart.");
    }
  };

  return (
    <div className="container-fluid Carts">
      <Navigation />
      <div className="container">
        <div className="table-responsive mt-5">
          <table className="table cart-table align-middle">
            <thead>
              <tr className="equal-columns">
                <th scope="col" className="fs-18">
                  Product
                </th>
                <th scope="col" className="fs-18 hide-md">
                  Product Details
                </th>
                <th scope="col" className="fs-18">
                  Price
                </th>
                <th scope="col" className="fs-18">
                  Quantity
                </th>
                <th scope="col" className="fs-18 hide-md">
                  Total Price
                </th>{" "}
                {/* Hidden after medium screen */}
                <th scope="col" className="fs-18  ">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {cartData.map((product, i) => (
                <tr key={product?._id} className="equal-columns cart-row">
                  {console.log("product", product)}
                  <td className="cart-product-cell" data-label="Product">
                    <div
                      className="proImg w-100"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate(
                          `/category/collection/product-detail?catid=${product?.category_id}&collectionId=${product?.collection_id}&productId=${product?.product_id}`
                        );
                      }}
                    >
                      {hasCustomization(product) ? (
                        <img loading="lazy" 
                          src={
                            product?.customized_image_id?.customized_image
                              ? Constants.imgDomain +
                              product?.customized_image_id?.customized_image
                              : color1
                          }
                          className=" p-4 w-100"
                          alt="Product"
                        />
                      ) : (
                        <img loading="lazy" 
                          src={
                            product?.images?.length > 0
                              ? Constants.imgDomain + product?.images[0]
                              : color1
                          }
                          className=" p-4 w-100"
                          alt="Product"
                        />
                      )}
                    </div>
                  </td>

                  <td className="fs-16 border-0 hide-md" data-label="Product Details">
                    <div className="top">
                      {/* <p className="fs-18 fw-normal">Custom Detail</p> */}
                      <small className="fs-16 fw-medium">
                        {hasCustomization(product) ? (
                          <>
                            {product?.customized_image_id?.size_id?.size_name} (
                            {product?.customized_image_id?.size_id?.size_code}{" "}
                            {
                              product?.customized_image_id?.size_id?.dimensions
                                ?.width
                            }
                            " x{" "}
                            {
                              product?.customized_image_id?.size_id?.dimensions
                                ?.height
                            }
                            ")
                          </>
                        ) : (
                          <>{product?.name}</>
                        )}
                      </small>
                      {product?.product_data &&
                        product?.product_data?.price_data && (
                          <div>
                            <p className="fs-16 fw-medium">
                              <span className="fw-bold">Fabric Price: </span>
                              $
                              {
                                JSON.parse(product?.product_data?.price_data)
                                  ?.fabric_price || 0
                              }
                            </p>
                          </div>
                        )}

                      {product?.product_data &&
                        product?.product_data?.price_data && (
                          <div>
                            <p className="fs-16 fw-medium">
                              <span className="fw-bold">Design Price: </span>
                              $
                              {
                                JSON.parse(product?.product_data?.price_data)
                                  ?.design_price || 0
                              }
                            </p>
                          </div>
                        )}

                      {product?.product_data &&
                        product?.product_data?.price_data && (
                          <div>
                            <p className="fs-16 fw-medium">
                              <span className="fw-bold">Text Price: </span>
                              $
                              {
                                JSON.parse(product?.product_data?.price_data)
                                  ?.text_price || 0
                              }
                            </p>
                          </div>
                        )}
                      {product?.product_data &&
                        product?.product_data?.matching_bag && (
                          <div>
                            <p className="fs-16 fw-medium">
                              <span className="fw-bold">Matching Bag: </span>
                              {
                                JSON.parse(product?.product_data?.matching_bag)
                                  ?.name
                              }
                              <br />
                              <span className="fw-bold">
                                {" "}
                                Matching Bag Price:{" "}
                              </span>
                              $
                              {
                                JSON.parse(product?.product_data?.matching_bag)
                                  ?.price || 0
                              }
                            </p>
                          </div>
                        )}


                    </div>

                    {/*  <button
                      className="btn btn-outline-danger rounded-5 btn-sm my-3"
                      onClick={() => {
                        if (!token) {
                          const data = cartData.filter(
                            (item) => item._id !== product._id
                          );
                          localStorage.setItem("cart", JSON.stringify(data));
                          dispatch(setCartItems(data));
                          setCartData(JSON.parse(JSON.stringify(data)));
                        } else {
                          handleRemoveFromCart([product._id]);
                        }
                      }}
                    >
                      <img loading="lazy" 
                        src="https://img.icons8.com/plasticine/25/filled-trash.png"
                        alt=""
                      />
                    </button> */}
                  </td>

                  {/* Product Price */}
                  <td className="border-0 fs-16" data-label="Price">
                    <p>
                      {hasCustomization(product) ? (
                        <>{getCartItemPrice(product)}$</>
                      ) : (
                        <>{getCartItemPrice(product)}$</>
                      )}
                    </p>
                  </td>

                  {/* Product Quantity */}
                  <td className="text-center border-0" data-label="Quantity">
                    <div className="d-flex align-items-center justify-content-center gap-2 fs-16 quantity-control">
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => {
                          if (!token) {
                            if (product.quantity > 1) {
                              product.quantity -= 1;
                              localStorage.setItem(
                                "cart",
                                JSON.stringify(cartData)
                              );
                              dispatch(setCartItems(cartData));
                              setCartData(
                                JSON.parse(JSON.stringify([...cartData]))
                              );
                            } else {
                              toast.clearWaitingQueue();
                              toast.dismiss();
                              toast.error("Quantity cannot be less than 1.");
                            }
                          } else {
                            updateQuantity({
                              cartId: product._id,
                              quantity: product.quantity - 1,
                            });
                          }
                        }}
                      >
                        -
                      </button>
                      <span className="quantity-number">
                        {product?.quantity}
                      </span>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => {
                          if (!token) {
                            product.quantity += 1;
                            localStorage.setItem(
                              "cart",
                              JSON.stringify(cartData)
                            );
                            dispatch(setCartItems(cartData));
                            setCartData(
                              JSON.parse(JSON.stringify([...cartData]))
                            );
                          } else {
                            updateQuantity({
                              cartId: product._id,
                              quantity: product.quantity + 1,
                            });
                          }
                        }}
                      >
                        +
                      </button>
                    </div>
                  </td>

                  {/* Total Price */}
                  <td className="fs-16 hide-md border-0" data-label="Total Price">
                    {" "}
                    {/* Hidden after medium screen */}
                    <p className="fs-16 fw-medium">
                      {hasCustomization(product) ? (
                        <>
                          {(
                            getCartItemPrice(product) *
                            Number(product?.quantity)
                          ).toFixed(2)}
                          $
                        </>
                      ) : (
                        <>
                          {(
                            Number(product?.price) * Number(product?.quantity)
                          ).toFixed(2)}
                          $
                        </>
                      )}
                    </p>
                  </td>

                  <td className="fs-16 border-0 cart-action-cell" data-label="Action">
                    <button
                      className="btn btn-outline-danger rounded-5 btn-sm my-3"
                      onClick={() => {
                        if (!token) {
                          const data = cartData.filter(
                            (item) => item._id !== product._id
                          );
                          localStorage.setItem("cart", JSON.stringify(data));
                          dispatch(setCartItems(data));
                          setCartData(JSON.parse(JSON.stringify(data)));
                        } else {
                          handleRemoveFromCart([product._id]);
                        }
                      }}
                    >
                      <img loading="lazy" 
                        src="https://img.icons8.com/plasticine/25/filled-trash.png"
                        alt=""
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Total Amount and Checkout Button */}
        <div className="d-flex justify-content-between mt-4 cart-summary flex-wrap gap-3">
          <div className="fs-18 cart-total">
            <strong>Total Amount:</strong> {totalAmount}$
          </div>
          <Link to="/checkout">
            {cartData.length > 0 && (
              <button
                type="button"
                // onClick={() => {
                //   if (token) {
                //     handleCheckout()
                //   } else {
                //     toast.clearWaitingQueue();
                //     toast.dismiss();
                //     toast.error("Please login to checkout");
                //     navigate("/login", { state: { locationPath: window.location.href } });
                //   }
                // }}
                className="btn btn-warning text-white fw-semibold px-5 fs-16 cart-checkout-btn"
              >
                Checkout
              </button>
            )}
          </Link>
        </div>
      </div>
    </div>
  );
};

// const CustomImage = ({ imageUrl }) => {
//   const [image, setImage] = useState(null);

//   useEffect(() => {
//     const img = new window.Image();
//     img.src = imageUrl;
//     img.onload = () => setImage(img);
//   }, [imageUrl]);

//   return image ? (
//     <KonvaImage image={image} x={0} y={0} width={150} height={150} />
//   ) : null;
// };

// const DetailRow = ({ label, value }) => (
//   <div className="d-flex justify-content-between w-50 text-start">
//     <p>{label}</p>
//     <p className="text-start w-25 text-gray ">{value}</p>
//   </div>
// );

export default Carts;
